const mediaQuery = (triggerWidth: number | string): string => {
  return `@media (max-width: ${triggerWidth}px)`;
};

export default mediaQuery;
